import React, { Component } from "react";
import PropTypes from "prop-types";
import Media from "react-media";
import Weekdays from "./Weekdays";
import Day from "./Day";

import * as ModifiersUtils from "./ModifiersUtils";
import * as Helpers from "./Helpers";
import * as DateUtils from "./DateUtils";
import Select from "react-select";

const currentYear = new Date().getFullYear();
const currentMonth = new Date().getMonth();
const fromMonth = new Date(currentYear, currentMonth);
const toMonth = new Date(currentYear + 50, 11);

export default class Month extends Component {
  static propTypes = {
    classNames: PropTypes.shape({
      body: PropTypes.string.isRequired,
      month: PropTypes.string.isRequired,
      outside: PropTypes.string.isRequired,
      today: PropTypes.string.isRequired,
      week: PropTypes.string.isRequired
    }).isRequired,
    tabIndex: PropTypes.number,

    month: PropTypes.instanceOf(Date).isRequired,
    months: PropTypes.arrayOf(PropTypes.string),

    modifiersStyles: PropTypes.object,

    enableOutsideDays: PropTypes.bool,

    renderDay: PropTypes.func.isRequired,

    captionElement: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func,
      PropTypes.instanceOf(React.Component)
    ]).isRequired,
    weekdayElement: PropTypes.oneOfType([
      PropTypes.element,
      PropTypes.func,
      PropTypes.instanceOf(React.Component)
    ]),

    footer: PropTypes.node,
    fixedWeeks: PropTypes.bool,
    showWeekNumbers: PropTypes.bool,

    locale: PropTypes.string.isRequired,
    localeUtils: PropTypes.object.isRequired,
    weekdaysLong: PropTypes.arrayOf(PropTypes.string),
    weekdaysShort: PropTypes.arrayOf(PropTypes.string),
    firstDayOfWeek: PropTypes.number.isRequired,

    onCaptionClick: PropTypes.func,
    onDayClick: PropTypes.func,
    onDayFocus: PropTypes.func,
    onDayKeyDown: PropTypes.func,
    onDayMouseEnter: PropTypes.func,
    onDayMouseLeave: PropTypes.func,
    onDayMouseDown: PropTypes.func,
    onDayMouseUp: PropTypes.func,
    onDayTouchEnd: PropTypes.func,
    onDayTouchStart: PropTypes.func,
    onWeekClick: PropTypes.func
  };

  YearMonthForm = (onChange, showCurrentYearOnly) => {
    const months = this.props.localeUtils.getMonths();
    const years = [];
    for (let i = fromMonth.getFullYear(); i <= toMonth.getFullYear(); i += 1) {
      years.push(i);
    }

    const logChange = function logChange(val) {
      let value = JSON.stringify(val.value);
      onChange(new Date(value, currentMonth));
    };
    function showCustomIcon() {
      return <i className="fa fa-chevron-down" aria-hidden="true" />;
    }
    let select_options = [];
    years.map((year, i) => select_options.push({ value: year, label: year }));
    return (
      <form className="DayPicker-Caption">
        <span className="month-name">
          {months[this.props.month.getMonth()]}
        </span>

        <Select
          name="year"
          className="year-selector"
          value={this.props.month.getFullYear()}
          options={select_options}
          onChange={showCurrentYearOnly ? null : logChange}
          arrowRenderer={showCurrentYearOnly ? null : showCustomIcon}
          clearable={false}
          searchable={false}
        />
      </form>
    );
  };

  renderDay = day => {
    const monthNumber = this.props.month.getMonth();
    const propModifiers = Helpers.getModifiersFromProps(this.props);
    const dayModifiers = ModifiersUtils.getModifiersForDay(day, propModifiers);
    if (
      DateUtils.isSameDay(day, new Date()) &&
      !Object.prototype.hasOwnProperty.call(
        propModifiers,
        this.props.classNames.today
      )
    ) {
      dayModifiers.push(this.props.classNames.today);
    }
    if (day.getMonth() !== monthNumber) {
      dayModifiers.push(this.props.classNames.outside);
    }

    const isOutside = day.getMonth() !== monthNumber;
    let tabIndex = -1;
    // Focus on the first day of the month
    if (this.props.onDayClick && !isOutside && day.getDate() === 1) {
      tabIndex = this.props.tabIndex;
    }
    const key = `${day.getFullYear()}${day.getMonth()}${day.getDate()}`;
    const modifiers = {};
    dayModifiers.forEach(modifier => {
      modifiers[modifier] = true;
    });

    return (
      <Day
        key={`${isOutside ? "outside-" : ""}${key}`}
        classNames={this.props.classNames}
        day={day}
        modifiers={modifiers}
        modifiersStyles={this.props.modifiersStyles}
        empty={
          isOutside && !this.props.enableOutsideDays && !this.props.fixedWeeks
        }
        tabIndex={tabIndex}
        ariaLabel={this.props.localeUtils.formatDay(day, this.props.locale)}
        ariaDisabled={isOutside || dayModifiers.indexOf("disabled") > -1}
        ariaSelected={dayModifiers.indexOf("selected") > -1}
        onClick={this.props.onDayClick}
        onFocus={this.props.onDayFocus}
        onKeyDown={this.props.onDayKeyDown}
        onMouseEnter={this.props.onDayMouseEnter}
        onMouseLeave={this.props.onDayMouseLeave}
        onMouseDown={this.props.onDayMouseDown}
        onMouseUp={this.props.onDayMouseUp}
        onTouchEnd={this.props.onDayTouchEnd}
        onTouchStart={this.props.onDayTouchStart}
      >
        {this.props.renderDay(day, modifiers)}
      </Day>
    );
  };

  handleYearMonthChange = month => {
    this.setState({ month });
  };

  render() {
    const {
      classNames,

      month,
      months,

      fixedWeeks,
      captionElement,
      weekdayElement,

      locale,
      localeUtils,
      weekdaysLong,
      weekdaysShort,
      firstDayOfWeek,

      onCaptionClick,

      footer,
      showWeekNumbers,
      onWeekClick
    } = this.props;
    const { showCurrentYearOnly = false } = this.props;

    const captionProps = {
      date: month,
      classNames,
      months,
      localeUtils,
      locale,
      onClick: onCaptionClick ? e => onCaptionClick(month, e) : undefined
    };
    const caption = React.isValidElement(captionElement)
      ? React.cloneElement(captionElement, captionProps)
      : React.createElement(captionElement, captionProps);

    const weeks = Helpers.getWeekArray(month, firstDayOfWeek, fixedWeeks);

    return (
      <div className="wrapper-without-navbar">
        {caption}

        <Media query="(max-width:991px)">
          {matches =>
            matches ? (
              <div className="clearfix">
                {this.YearMonthForm(
                  this.handleYearMonthChange,
                  showCurrentYearOnly
                )}
              </div>
            ) : null
          }
        </Media>

        <Weekdays
          classNames={classNames}
          weekdaysShort={weekdaysShort}
          weekdaysLong={weekdaysLong}
          firstDayOfWeek={firstDayOfWeek}
          showWeekNumbers={showWeekNumbers}
          locale={locale}
          localeUtils={localeUtils}
          weekdayElement={weekdayElement}
        />

        <div className={classNames.month} role="grid">
          <div className={classNames.body} role="rowgroup">
            {weeks.map(week => {
              let weekNumber;
              if (showWeekNumbers) {
                weekNumber = DateUtils.getWeekNumber(week[0]);
              }
              return (
                <div
                  key={week[0].getTime()}
                  className={classNames.week}
                  role="row"
                >
                  {showWeekNumbers && (
                    <div
                      className={classNames.weekNumber}
                      tabIndex={0}
                      role="gridcell"
                      onClick={e => onWeekClick(weekNumber, week, e)}
                    >
                      {weekNumber}
                    </div>
                  )}
                  {week.map(this.renderDay)}
                </div>
              );
            })}
          </div>
          {footer && <div className={classNames.footer}>{footer}</div>}
        </div>
      </div>
    );
  }
}
